// Отказ, сказанный человеку словами.
//
// Ошибка из нативного слоя приходит НЕ объектом Error, а строкой: плагин Tauri отвечает
// `invoke.reject("печать недоступна: окно ещё не готово")`, и на стороне интерфейса это
// обычная строка. Проверка `ошибка instanceof Error` её не ловит, и человек вместо готового
// объяснения получает общую фразу — ровно в том месте, где нативный слой единственный раз и
// умеет объяснить, что произошло.
//
// Поймано 11.09.2026 живым прогоном на планшете: выгрузка отказала, а на экране было
// «сервер не отдал файл» — при том что сервер файл отдал, и дело было вовсе не в нём.

export function текстОшибки(ошибка: unknown, запасной: string): string {
  if (typeof ошибка === 'string' && ошибка.trim() !== '') {
    return ошибка.trim();
  }
  if (ошибка instanceof Error && ошибка.message !== '') {
    return ошибка.message;
  }
  // Плагин может ответить и объектом с полем сообщения — у Tauri это бывает при ошибке
  // разбора прав.
  if (ошибка !== null && typeof ошибка === 'object') {
    const поле = (ошибка as { message?: unknown }).message;
    if (typeof поле === 'string' && поле.trim() !== '') {
      return поле.trim();
    }
  }
  return запасной;
}
